export default "__VITE_ASSET__CjSpvENw__"